// Communication Management copy of ParentNotificationModal.
// Logic is identical to ../../Parent Notifications/ParentNotificationModal.jsx;
// only the layout (Branch/Class/Section on a single row) and the dropdown /
// input styling differ. Kept as a separate file so the standalone
// /Parent_Notification module is NOT affected.

import React, { Component } from 'react'
import { Col, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { components } from 'react-select'
import moment from "moment";
import MultiSelect from "react-multi-select-component";
import TextEditor from '../../text_editor/TextEditor';
import ErrorBoundary from '../../common/ErrorBoundary';
import '../../Parent Notifications/_parentNotification.scss';
import './_commParentNotification.scss';
import { attachModuleGuard, AccessDeniedModal } from "../../../../utils/moduleGuard";
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../../utils/authHelper";

const showStream = (classId) => String(classId) === "1" || String(classId) === "2";

const GET_STREAMS = gql`
  query getStreams {
    getStreams {
      id
      stream
      classes
    }
  }
`;

// /communication-management/* → "communication_management". Match on module_key only.
// The section that opens this modal already gates the opener; this file re-checks at
// the submit because that's where the send actually happens.
const COMMUNICATION_MODULE = ["communication_management"];

const ADD_PARENT_CUSTOM_NOTIFICATION = gql`
  mutation($params:SendParentCustomNotification){
        sendParentCustomNotification(
        params: $params
    )}`;

// ── Expense-style filter services (branches with sections + class list) ───────
const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        stream_id
        section_name
        class_id
        subjects {
          subject_id
          subject_name
        }
      }
    }
  }
`;

const GET_EXAM_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

// Branch react-select styles (border radius + indigo focus to match the design).
const branchSelectStyles = {
    control: (base) => ({ ...base, minHeight: 42 }),
    option: (provided, state) => ({ ...provided, color: state.isSelected ? "white" : "black" }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
};

class CommParentNotificationModal extends Component {
    constructor(props) {
        super();
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

        this.state = {
            branches: [],
            allClasses: [],
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],
            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],
            studentsOptions: [],
            selectedStudents: [],
            students_error: "",
            branchWiseData: [],
            classWiseStudentData: [],
            sectionWiseStudentData: [],
            title: "",
            title_error: "",
            subTitle: "",
            subTitle_error: "",
            schedule_time: currentDateTime,
            ldescription: "",
            ldescription_error: "",
            loader: 0,
            submitError: "",
            submitted: false,
            accessDeniedShow: false
        }

        this.guard = attachModuleGuard(this, COMMUNICATION_MODULE);
    }

    async componentDidMount() {
        // is_view === 0 → don't fetch the branch/class dropdowns. These are imperative
        // client.query() calls, so the section's `skip` doesn't cover them.
        if (!this.guard.canView()) return;

        try {
            const [branches, allClasses] = await Promise.all([this.fetchBranches(), this.fetchClasses()]);
            this.setState({ branches, allClasses }, () => {
                if (branches.length > 0) this.applyBranch(branches[0].id);
            });
        } catch (e) {
            console.error("Parent notification filter load failed", e);
        }
    }

    fetchBranches = async () => {
        const institution_id = parseInt(Cookies.get("institutionid"));
        const res = await this.props.client.query({
            query: GET_BRANCHES,
            variables: { institution_id },
            fetchPolicy: "network-only",
        });
        let branches = res.data.getBranches || [];
        const authorizedIds = getAuthorizedBranchIds();
        if (authorizedIds.length) {
            branches = branches.filter((b) => authorizedIds.includes(String(b.id)));
        }
        const allowedClasses = getAuthorizedClassIds();
        const allowedSections = getAuthorizedSectionIds();
        if (allowedClasses.length || allowedSections.length) {
            branches = branches.map((b) => ({
                ...b,
                sections: filterByAuthorizedIds(
                    filterByAuthorizedIds(b.sections || [], allowedSections, "id"),
                    allowedClasses,
                    "class_id"
                ),
            }));
        }
        return branches;
    };

    fetchClasses = async () => {
        const res = await this.props.client.query({
            query: GET_EXAM_CLASSES,
            variables: { id: 1 },
            fetchPolicy: "network-only",
        });
        const classes = res.data.getExamClasses || [];
        return filterByAuthorizedIds(classes, getAuthorizedClassIds(), "id");
    };

    applyBranch = (branchId) => {
        const branch = this.state.branches.find((b) => String(b.id) === String(branchId));
        const sections = branch ? (branch.sections || []) : [];

        const classIds = [...new Set(sections.map((s) => Number(s.class_id)))];
        const getClassArr = this.state.allClasses
            .filter((c) => classIds.includes(Number(c.id)))
            .map((c) => ({ value: c.id, label: c.class }));

        const seen = new Set();
        const getSectionArr = [];
        sections.forEach((s) => {
            if (!seen.has(s.id)) { seen.add(s.id); getSectionArr.push({ value: s.id, label: s.section_name }); }
        });

        const StudentsData = this.props.getNewEducationalStudents || [];
        const branchWiseData = StudentsData.filter((a) => a.branch_id == branchId).map((item) => ({ ...item }));
        const studentsArray = branchWiseData.map((item) => ({
            value: item.student_id,
            label: `${item.roll_no} => ${item.student_name}`,
            parent_mobile: item.parent_mobile,
        }));

        this.setState({
            branchSearchval: branch ? { value: branch.id, label: branch.branch_name } : "",
            branch: branch ? branch.branch_name : "",
            branchSearch: branchId,
            branchError: "",
            getClassArr,
            classSelectedvalue: getClassArr,
            getSectionArr,
            sectionSelectedvalue: getSectionArr,
            studentsOptions: studentsArray,
            selectedStudents: studentsArray,
            branchWiseData,
            classWiseStudentData: branchWiseData,
            sectionWiseStudentData: branchWiseData,
        });
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (name == "class") {
            let classSelectedvalue = e ? e.map((c) => ({ label: c.label, value: c.value })) : [];

            if (classSelectedvalue.length > 0) {
                const branch = this.state.branches.find((b) => String(b.id) === String(this.state.branchSearch));
                const sections = branch ? (branch.sections || []) : [];
                const selectedClassIds = classSelectedvalue.map((c) => Number(c.value));
                const seen = new Set();
                const getSectionArr = [];
                sections
                    .filter((s) => selectedClassIds.includes(Number(s.class_id)))
                    .forEach((s) => {
                        if (!seen.has(s.id)) { seen.add(s.id); getSectionArr.push({ value: s.id, label: s.section_name }); }
                    });

                const branchWiseData = this.state.branchWiseData || [];
                let classWiseData = [];
                classSelectedvalue.forEach((c) => {
                    classWiseData.push(...branchWiseData.filter((student) => student.class_id == c.value));
                });
                const studentsArray = classWiseData.map((item) => ({
                    value: item.student_id,
                    label: `${item.roll_no} => ${item.student_name}`,
                    parent_mobile: item.parent_mobile,
                }));

                this.setState({
                    classSelectedvalue,
                    classError: "",
                    getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    classWiseStudentData: classWiseData,
                    sectionWiseStudentData: classWiseData,
                });
            } else {
                this.setState({
                    classSelectedvalue: [],
                    classError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "section") {
            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    sectionSelectedvalue.push({ label: sectionval.label, value: sectionval.value });
                }

                let classWiseStudentData = this.state.classWiseStudentData;
                let studentsArray = [];
                let sectionWiseStudentData = [];

                if (classWiseStudentData.length > 0) {
                    e.map((section) => {
                        let data = classWiseStudentData.filter((student) => student.section_id == section.value);
                        sectionWiseStudentData.push(...data)
                    });

                    sectionWiseStudentData.map((item) => {
                        studentsArray.push({
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`,
                            parent_mobile: item.parent_mobile
                        });
                    });
                }

                this.setState({
                    sectionSelectedvalue,
                    sectionError: "",
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    sectionWiseStudentData,
                });
            } else {
                this.setState({
                    sectionSelectedvalue: [],
                    sectionError: "",
                    studentsOptions: [],
                    selectedStudents: [],
                });
            }
        }

        if (name == "student") {
            let studenttopicvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const stuval = e[i];
                    studenttopicvalue.push({
                        label: stuval.label,
                        value: stuval.value,
                        parent_mobile: stuval.parent_mobile
                    });
                }
                this.setState({ selectedStudents: studenttopicvalue, students_error: "" });
            }
        }
    }

    branchOptions = () => this.state.branches.map((b) => ({ value: b.id, label: b.branch_name }));

    handleBranchChange = (option) => {
        if (option && option.value != "0") {
            this.applyBranch(option.value);
        }
    }

    handleFormChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "title") this.setState({ title: value, title_error: "" })
        if (name == "subTitle") this.setState({ subTitle: value, subTitle_error: "" })
        if (name == "schedule_time") this.setState({ schedule_time: value })
    }

    handleEditorChange = (content) => {
        this.setState({ ldescription: content, ldescription_error: "" })
    }

    handleFormSubmit = e => {
        e.preventDefault();

        // Re-checked at submit, not only at the opener in the section: the modal could
        // already be open when a grant changes. Ahead of the field validation, so a role
        // without is_edit is told they lack access rather than being sent to fix a form
        // they were never allowed to submit.
        if (!this.guard.requireEdit()) return "";

        if (!this.state.classSelectedvalue.length) { this.setState({ classError: "Please select class" }); return "" }
        if (!this.state.sectionSelectedvalue.length) { this.setState({ sectionError: "Please select section" }); return "" }
        if (!this.state.selectedStudents.length) { this.setState({ students_error: "Please select students" }); return "" }
        if (this.state.title == "") { this.setState({ title_error: "Please enter title" }); return "" }
        if (this.state.subTitle == "") { this.setState({ subTitle_error: "Please enter message" }); return "" }
        if (this.state.ldescription == "") { this.setState({ ldescription_error: "Please enter description" }); return "" }

        const params = {
            branch_id: this.state.branchSearch,
            institute_id: parseInt(Cookies.get("institutionid")),
            class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
            section_id: this.state.sectionSelectedvalue.map((sectionid) => sectionid.value).toString(),
            notification_title: this.state.title,
            notification_subtitle: this.state.subTitle,
            long_description: this.state.ldescription,
            schedule_time: moment(this.state.schedule_time).unix().toString(),
            parent_mobile: this.state.selectedStudents.filter((a) => a.parent_mobile != null).map((i) => i.parent_mobile).toString(),
            exam_id: ""
        }

        this.setState({ loader: 1 });
        this.addParentCustomNotification(params);
    }

    // Last gate before sendParentCustomNotification leaves the client.
    addParentCustomNotification = async (params) => {
        if (!this.guard.requireEdit()) return;

        try {
            await this.props.addParentCustomNotification({
                variables: { params },
                update: (store, { data }) => {
                    if (data && data.sendParentCustomNotification) {
                        if (this.props.refetchNotifications) this.props.refetchNotifications();
                        this.props.onHide();
                    } else {
                        console.error("sendParentCustomNotification returned false/null", data);
                        this.setState({ loader: 0, submitError: "Failed to send notification. Please try again." });
                    }
                },
            });
        } catch (err) {
            console.error("addParentCustomNotification error:", err);
            this.setState({ loader: 0, submitError: err.message || "An error occurred. Please try again." });
        }
    };

    render() {
        let classlabelledBy = "Select";
        let classdisableSearch = false;
        let classselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;
        let sectionselectall = true;
        let studentlabelledBy = "Select";
        let studentdisablesearch = false;
        let studentselectall = true;

        if (this.state.getClassArr.length > 0) { classselectall = true; classdisableSearch = false; }
        else { classdisableSearch = true; classselectall = false; classlabelledBy = "Class" }

        if (this.state.getSectionArr.length > 0) { sectionselectall = true; sectiondisableSearch = false; }
        else { sectiondisableSearch = true; sectionselectall = false; sectionlabelledBy = "Section" }

        if (this.state.studentsOptions.length > 0) { studentselectall = true; studentdisablesearch = false; }
        else { studentdisablesearch = true; studentselectall = false; studentlabelledBy = "student" }

        const selectedBranchData = (this.state.branches || []).find((b) => String(b.id) === String(this.state.branchSearch));
        const streamIds = [...new Set(((selectedBranchData && selectedBranchData.sections) || []).filter(s => s.stream_id).map(s => s.stream_id))];
        const streamOptions = streamIds.map(sid => ({ value: sid, label: `Stream ${sid}` }));
        const colSize = streamOptions.length > 0 ? 3 : 4;

        return (
            <>
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                size="lg"
                dialogClassName="pn-modal comm-pn-modal"
                aria-labelledby="comm-parent-notification-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title><i className="fas fa-bell" /> Send Parent Notification</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Row>
                            {/* Branch / Class / Stream / Section — single row */}
                            <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="SelectBranch">
                                <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                <Select
                                    classNamePrefix="comm-rs"
                                    styles={branchSelectStyles}
                                    components={{ DropdownIndicator }}
                                    placeholder="Branch"
                                    value={this.state.branchSearchval || null}
                                    onChange={this.handleBranchChange}
                                    options={this.branchOptions()}
                                    isClearable={false}
                                    isSearchable={true}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                                    menuPosition="fixed"
                                    maxMenuHeight={200}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="SelectClass">
                                <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                <MultiSelect
                                    overrideStrings={{ "allItemsAreSelected": "All Classes are selected.", "selectSomeItems": classlabelledBy }}
                                    disableSearch={classdisableSearch}
                                    hasSelectAll={classselectall}
                                    options={this.state.getClassArr}
                                    value={this.state.classSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                    labelledBy={"class"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.classError}</Form.Text>
                            </Form.Group>

                            {streamOptions.length > 0 && (
                                <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="SelectStream">
                                    <Form.Label className="text-uppercase font-weight-bold">Stream</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{ "allItemsAreSelected": "All Streams are selected.", "selectSomeItems": "Stream" }}
                                        options={streamOptions}
                                        value={this.state.streamSelectedvalue || streamOptions}
                                        onChange={(v) => this.setState({ streamSelectedvalue: v })}
                                        labelledBy={"stream"}
                                    />
                                </Form.Group>
                            )}

                            <Form.Group as={Col} lg={colSize} md={6} sm={12} controlId="SelectSection">
                                <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                <MultiSelect
                                    overrideStrings={{ "allItemsAreSelected": "All Sections are selected.", "selectSomeItems": sectionlabelledBy }}
                                    disableSearch={sectiondisableSearch}
                                    hasSelectAll={sectionselectall}
                                    options={this.state.getSectionArr}
                                    value={this.state.sectionSelectedvalue}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                    labelledBy={"section"}
                                />
                                <Form.Text className="form-text text-danger"> {this.state.sectionError}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectStudent">
                                <Form.Label className="text-uppercase font-weight-bold">Students</Form.Label>
                                <MultiSelect
                                    overrideStrings={{ "allItemsAreSelected": "All Students are selected.", "selectSomeItems": studentlabelledBy }}
                                    disableSearch={studentdisablesearch}
                                    hasSelectAll={studentselectall}
                                    options={this.state.studentsOptions}
                                    value={this.state.selectedStudents}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "student")}
                                    labelledBy={"student"}
                                />
                                <Form.Text className="form-text text-danger">{this.state.students_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Title</Form.Label>
                                <Form.Control placeholder='Enter Title' name='title' onChange={this.handleFormChange} value={this.state.title}></Form.Control>
                                <Form.Text className="form-text text-danger">{this.state.title_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Notification Subtitle</Form.Label>
                                <Form.Control type="text" placeholder="Enter subTitle" name="subTitle" onChange={this.handleFormChange} value={this.state.subTitle} />
                                <Form.Text className="form-text text-danger">{this.state.subTitle_error}</Form.Text>
                            </Form.Group>

                            <Form.Group as={Col} lg={6} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Schedule Time</Form.Label> <br />
                                <Form.Control
                                    type="datetime-local"
                                    name="schedule_time"
                                    onChange={this.handleFormChange}
                                    value={this.state.schedule_time}
                                    onClick={(e) => { try { e.currentTarget.showPicker && e.currentTarget.showPicker(); } catch (err) { /* showPicker unsupported / not user-activated */ } }}
                                    onFocus={(e) => { try { e.currentTarget.showPicker && e.currentTarget.showPicker(); } catch (err) { /* ignore */ } }}
                                    style={{ cursor: "pointer" }}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={12} md={12} sm={12}>
                                <Form.Label className="text-uppercase font-weight-bold">Long Description</Form.Label>
                                <ErrorBoundary fallback={<div className="alert alert-warning">Editor could not be loaded. Please refresh.</div>}>
                                    <TextEditor handleEditorChange={this.handleEditorChange} value={this.state.ldescription} />
                                </ErrorBoundary>
                                <Form.Text className="form-text text-danger"> {this.state.ldescription_error} </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 d-flex flex-column align-items-end">
                        <button className="pn-modal-submit" onClick={this.handleFormSubmit} disabled={this.state.loader == 1}>
                            {this.state.loader == 1 ? (<span className="spinner-border spinner-border-sm"></span>) : (<i className="fas fa-paper-plane" />)}
                            Send Notification
                        </button>
                        {this.state.submitError && this.state.submitError != "" && (
                            <span className="text-danger mt-2">{this.state.submitError}</span>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Rendered as a sibling of the form Modal (not nested inside it) so it can
                stack above it when a submit is intercepted. */}
            <AccessDeniedModal
                show={this.state.accessDeniedShow}
                onHide={this.guard.hideAccessDenied}
            />
            </>
        )
    }
}

export default compose(
    withApollo,
    graphql(ADD_PARENT_CUSTOM_NOTIFICATION, { name: "addParentCustomNotification" })
)(CommParentNotificationModal);
